import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../enums/index';
import * as cafeEventsActions from '../../redux/cafeEvents/actions';
import Spin from '../../components/loading';
import CafeEventDetails from './modals/cafeEventDetails';
import ShowForPermission from '../../components/ShowForPermission';
import { enumHelper } from '../../utils';
import generateClassName from '../../utils/generateClassName';

class CafeEventsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cafeEventOpen: false,
      selectedCafeEventId: null,
      sortType: 'asc',
      status: '',
      isActive: false,
      sortedColumn: ''
    };
  }

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  displayCafeEventModal = id => {
    let { cafeEventsList } = this.props;
    let selectedCafeEventId = cafeEventsList.filter(request => request.id == id)[0].id;
    this.setState({ cafeEventOpen: true, selectedCafeEventId });
  };

  closeCafeEventModal = () => {
    this.setState(() => ({
      cafeEventOpen: false
    }));
  };

  renderStatusColors = status => {
    const { CONFIRMED, DISABLED, REJECTED, REQUESTED } = ENUMS.EVENT_STATUS.values;
    switch (status) {
      case CONFIRMED:
        return 'text-success';
      case DISABLED:
        return 'text-muted';
      case REJECTED:
        return 'text-danger';
      case REQUESTED:
        return 'text-info';
      default:
        return 'text-dark';
    }
  };

  render() {
    let {
      cafeEventsList = [],
      pageNumber,
      pageSize,
      sortType,

      cafeEventsLoading,
      cafeEventsMessage,
      cafeEventsError,
      cafeEventsFailed
    } = this.props;
    return (
      <>
        <Spin spinning={cafeEventsLoading}>
          {cafeEventsError && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {cafeEventsFailed && <div className="alert alert-danger">{cafeEventsMessage}</div>}
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th onClick={() => this.sortTable('name')} className="text-center pointer">
                  <i name="name" className={generateClassName('name', this.state.sortedColumn, sortType)} />
                  {locales('modal.user.full.name')}
                </th>
                <th onClick={() => this.sortTable('fromDate')} className="text-center pointer">
                  <i
                    name="fromDate"
                    className={generateClassName('fromDate', this.state.sortedColumn, sortType)}
                  />
                  {locales('labels.from.date')}
                </th>
                <th onClick={() => this.sortTable('toDate')} className="text-center pointer">
                  <i
                    name="toDate"
                    className={generateClassName('toDate', this.state.sortedColumn, sortType)}
                  />
                  {locales('labels.to.date')}
                </th>
                <th className="text-center">{locales('fields.weed.days')}</th>
                <th className="text-center">{locales('tables.status')}</th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {cafeEventsList.length ? (
                cafeEventsList.map((cafeEvent, index) => (
                  <tr key={cafeEvent.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{cafeEvent.name}</td>
                    <td className="text-center">{cafeEvent.fromDate}</td>
                    <td className="text-center">{cafeEvent.toDate}</td>
                    <td className={`text-center`}>{cafeEvent.weekdays}</td>
                    <td className={`text-center ${this.renderStatusColors(cafeEvent.status)}`}>
                      {enumHelper.convertEnumValueToTitle(ENUMS.EVENT_STATUS.list, cafeEvent.status)}
                    </td>
                    <td title={locales('titles.editCafeEvent')} className="pointer text-center">
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_EVENT_REQUEST}>
                        <NavLink
                          to={{ pathname: '/cafe-events/edit', editMode: true, eventId: cafeEvent.id }}
                        >
                          <i className="far fa-pencil-alt" />
                        </NavLink>
                      </ShowForPermission>
                    </td>
                    <td title={locales('titles.eventDetails')} className="pointer text-center">
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENT_DETAILS}>
                        <i
                          onClick={() => this.displayCafeEventModal(cafeEvent.id)}
                          className="far fa-info-circle"
                        />
                      </ShowForPermission>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {this.state.cafeEventOpen && (
            <CafeEventDetails
              isOpen={this.state.cafeEventOpen}
              eventId={this.state.selectedCafeEventId}
              closeModal={this.closeCafeEventModal}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeEventsList: state.cafeEventsReducer.cafeEventsList,
    cafeEvents: state.cafeEventsReducer.cafeEvents,
    cafeEventsFailed: state.cafeEventsReducer.cafeEventsFailed,
    cafeEventsError: state.cafeEventsReducer.cafeEventsError,
    cafeEventsMessage: state.cafeEventsReducer.cafeEventsMessage,
    cafeEventsLoading: state.cafeEventsReducer.cafeEventsLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeEvents: query => dispatch(cafeEventsActions.fetchAllCafeEvents(query))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CafeEventsTable)
);
